import type { Vault } from '@/types/vault'

export function isVaultInProtocols(vault: Vault, protocols: string[]): boolean {
  if (protocols.length === 0) return true
  return protocols.includes(vault.protocol.name)
}
